module.exports = __webpack_public_path__ + "static/media/bass-cello.f4f6ebd6.mp3";